export const getPercentage = (percentage: number, locale: string) => {
  return new Intl.NumberFormat(locale, {
    style: "percent",
    maximumFractionDigits: 0,
  }).format(percentage / 100);
};
